<mat-expansion-panel [expanded]="autoExpand" class="mat-elevation-z0">
  <mat-expansion-panel-header>
    <mat-panel-title class="bold">
      {{ 'common.labels.filters' | transloco }}
    </mat-panel-title>
  </mat-expansion-panel-header>
  <form [formGroup]="_filterForm" class="padding">
    <div class="flex-container">
      <mat-form-field class="form-field">
        <mat-select formControlName="systemEventTypeIDs" [placeholder]="'common.labels.eventType' | transloco" multiple="true">
          @for (option of _systemEventTypes; track option) {
            <mat-option [value]="option.value">
              {{ option.label }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field class="form-field">
        <mat-select formControlName="orderTypeID" [placeholder]="'common.labels.orderType' | transloco">
          @for (option of _orderTypes; track option) {
            <mat-option [value]="option.value">
              {{ option.label }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <lib-jurisdiction-selection (formReady)="jurisdictionFormChanges($event)"></lib-jurisdiction-selection>
    <div class="flex-container">
      <mat-form-field class="form-field">
        <mat-label>{{ 'common.labels.dateStartFrom' | transloco }}</mat-label>
        <input matInput [matDatepicker]="startDateFrom" [formControlName]="'startDateFrom'"
          [placeholder]="'common.labels.dateStartedFrom' | transloco">
        <mat-datepicker-toggle matSuffix [for]="startDateFrom"></mat-datepicker-toggle>
        <mat-datepicker #startDateFrom></mat-datepicker>
      </mat-form-field>
      <mat-form-field class="form-field">
        <mat-label>{{ 'common.labels.dateStartTo' | transloco }}</mat-label>
        <input matInput [matDatepicker]="dateStartedTo" [formControlName]="'dateStartedTo'"
          [placeholder]="'common.labels.dateStartTo' | transloco">
        <mat-datepicker-toggle matSuffix [for]="dateStartedTo"></mat-datepicker-toggle>
        <mat-datepicker #dateStartedTo></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="flex-container">
      <mat-form-field class="form-field">
        <mat-label>{{ 'common.labels.dateEndFrom' | transloco }}</mat-label>
        <input matInput [matDatepicker]="endDateFrom" [formControlName]="'endDateFrom'"
          [placeholder]="'common.labels.dateEndFrom' | transloco">
        <mat-datepicker-toggle matSuffix [for]="endDateFrom"></mat-datepicker-toggle>
        <mat-datepicker #endDateFrom></mat-datepicker>
      </mat-form-field>
      <mat-form-field class="form-field">
        <mat-label>{{ 'common.labels.dateEndTo' | transloco }}</mat-label>
        <input matInput [matDatepicker]="endDateTo" [formControlName]="'endDateTo'" [placeholder]="'common.labels.dateEndTo' | transloco">
        <mat-datepicker-toggle matSuffix [for]="endDateTo"></mat-datepicker-toggle>
        <mat-datepicker #endDateTo></mat-datepicker>
      </mat-form-field>
    </div>
    <div>
      <button mat-raised-button color="accent" class="margin-sides-5" [attr.aria-label]="'common.labels.clearFiltersButton' | transloco" type="button"
        (click)="onClear()" [disabled]="!_filterForm.dirty">
        {{ 'common.labels.clearFilters' | transloco }}
      </button>
      <button mat-raised-button color="accent" class="margin-sides-5" [attr.aria-label]="'common.labels.filterButton' | transloco" type="submit"
        (click)="onFilter()">
        {{ 'common.labels.filter' | transloco }}
      </button>
    </div>
  </form>
</mat-expansion-panel>